export const GET_UNCONFIRMED_EMPLOYEES = 'GET_UNCONFIRMED_EMPLOYEES';
export const GET_CONFIRMED_EMPLOYEES = 'GET_CONFIRMED_EMPLOYEES';
